import { Helmet } from 'react-helmet-async';

/**
 * Injects a JSON-LD structured-data block into <head> via react-helmet-async.
 * Accepts a single object or an array of objects. Each becomes one script tag.
 */
export default function JsonLd({ data }) {
    const items = Array.isArray(data) ? data : [data];
    return (
        <Helmet>
            {items.filter(Boolean).map((obj, i) => (
                <script key={i} type="application/ld+json">
                    {JSON.stringify(obj)}
                </script>
            ))}
        </Helmet>
    );
}

/**
 * Convert seconds -> ISO 8601 duration (e.g. 402 -> "PT6M42S").
 * Returns undefined for falsy input so callers can spread it conditionally.
 */
export function isoDuration(seconds) {
    if (!seconds || seconds <= 0) return undefined;
    const s = Math.floor(seconds);
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const sec = s % 60;
    let out = 'PT';
    if (h) out += `${h}H`;
    if (m) out += `${m}M`;
    if (sec || (!h && !m)) out += `${sec}S`;
    return out;
}
